export const columnsDataPriceIncreases = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Porcentaje",
    accessor: "percentage",
    computedValue: (row) => `${row.percentage}%`,
  },
  {
    Header: "Fecha de Aplicación",
    accessor: "applicationDate",
    computedValue: (row) => {
      if (!row.applicationDate) return '-';
      return new Date(row.applicationDate).toLocaleDateString('es-ES');
    },
  },
  {
    Header: "Tipo de Aplicación",
    accessor: "applicationType",
    computedValue: (row) => {
      const typeLabels = {
        'all_courses': 'Todos los dictados',
        'courses_with_payment': 'Dictados con modalidad de pago',
        'specific_courses': 'Dictados específicos'
      };
      return typeLabels[row.applicationType] || row.applicationType;
    },
  },
  {
    Header: "Fecha de Creación",
    accessor: "createdDate",
    computedValue: (row) => {
      return new Date(row.createdDate).toLocaleDateString('es-ES');
    },
  },
  {
    Header: "Estado",
    accessor: "enabled",
    computedValue: (row) => row.enabled ? 'Activo' : 'Inactivo',
  },
];
